import React, { Component } from 'react';
import whiteLabel from '../../lib/whiteLabel'
import MaskedInput from 'react-text-mask'
import { checkPortability } from '../../lib/ALIANZA_API_V2'
import { assign } from 'lodash'
import './App.css';

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      phoneNumber: '',
      availability: null,
      isSubmitting: false
    }
  }

  getYesMessage = () => {
    const {availability} = this.state;
    return `Yes! The telephone number ${availability.phoneNumber} located in ${availability.rateCenterName}, ${availability.rateCenterState} is in an area that the Viasat Voice telephone service supports.`
  }

  getNoMessage = () => {
    const {availability} = this.state;
    return `
      No. The telephone number ${availability.phoneNumber} is in an area not supported by the Viasat Voice telephone service;
      however, we still may be able to support your phone needs (see instructions below).
    `
  }

  getAdditionalMessageForReject = () => {
    return `
      Important: Viasat Voice may not be available in your telephone rate center*.
      If this situation applies to you: 
        (i) ViaSat will not be able to transfer ("port") your current telephone number to our Viasat Voice service and we will have to provide you with a new phone number, and
        (ii) ViaSat will not be able to provide a local telephone number to the rate center associated with your home address. 
      This means that after we activate your Viasat Voice service, certain calls to you from within your telephone rate center may be long distance calls for the caller.
      Long-distance calling to the United States and Canada is included in your Viasat Voice service at no additional charge, and so this situation will only affect certain inbound calls to you and will not affect your outbound calls.
    `
  }

  getRateCenterHelperText = () => {
    return `
      *Rate centers are the geographic service areas in which local telephone companies divide their customers. 
    `
  }

  onChangePhoneNumber = (e) => {
    this.setState({
      phoneNumber: e.target.value
    })
  }

  onSubmit = () => {
    const phoneNumber = this.state.phoneNumber.replace(/[^0-9]/g, '')

    this.setState({
      isSubmitting: true
    }, () => {
      checkPortability(phoneNumber).then(response => {
        this.setState({
          availability: assign({}, {phoneNumber: this.state.phoneNumber}, response.data),
          isSubmitting: false
        })
      })
    })
  }

  onKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.onSubmit()
    }
  }

  render() {
    return (
      <div>
        <header>
          <img src={whiteLabel.getWhiteLabelData().logo} className='logo' alt='logo' />
          <div className="header-bar"></div>
        </header>
        <div className="page">
          <h1 className="page-title">Telephone Number Availability</h1>
          <p className="bigger">
            Prior to offering a customer Telephone service, use this tool to check the serviceability of their desired telephone number first.
          </p>
          <div className="instructions">Instructions</div>
          <p>
            1. Enter the requested telephone number, including the area code, using the format below.
          </p>
          <p>
            2. Click Submit.
          </p>
          <div>
            <MaskedInput
              mask={['1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              onChange={this.onChangePhoneNumber}
              onKeyDown={this.onKeyDown}
            />
          </div>
          <div>
            <button onClick={this.onSubmit}>Submit</button>
          </div>
          <div className="results">
            {this.state.availability !== null && (
              <div>
                {this.state.availability.portingSupported && (
                  <div className="alert alert-success" role="alert">
                    {this.getYesMessage()}
                  </div>
                )}
                {!this.state.availability.portingSupported && (
                  <div className="alert alert-danger" role="alert">
                    {this.getNoMessage()}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {this.state.availability && !this.state.availability.portingSupported && (
          <div>
            <p>
              {this.getAdditionalMessageForReject()}
            </p>
            <p>
              {this.getRateCenterHelperText()}
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js